var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 63,
    viewBox: "0 0 33 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3198 46.6501C32.3198 55.4201 25.0298 62.6501 16.2598 62.6501C10.4398 62.6501 5.24976 59.4501 3.64977 56.7601V62.5201H0.259766V0.0600586H3.64977V36.5401C5.24976 33.9201 10.4298 30.6501 16.2598 30.6501C25.0298 30.6501 32.3198 37.8801 32.3198 46.6501ZM28.8598 46.6501C28.8598 39.6101 23.3598 34.0401 16.2498 34.0401C9.13977 34.0401 3.63977 39.6101 3.63977 46.6501C3.63977 53.6901 9.20977 59.2601 16.2498 59.2601C23.2898 59.2601 28.8598 53.6901 28.8598 46.6501Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerB);
export default __webpack_public_path__ + "static/media/LOWER_B.e2ab0600e709a065f9af99ae5114fa79.svg";
export { ForwardRef as ReactComponent };